import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5923 12.5H5.43893C4.97302 12.5 4.69513 11.9807 4.95356 11.5931L6.38707 9.44283C6.55431 9.19197 6.88516 9.10989 7.15027 9.25349L7.84574 9.6302C8.10405 9.77012 8.4261 9.69612 8.59743 9.45749L9.69067 7.93476C9.9284 7.60364 10.4238 7.61223 10.6499 7.95139L13.0777 11.5931C13.3361 11.9807 13.0582 12.5 12.5923 12.5Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.55729 7.25C8.04054 7.25 8.43229 6.85825 8.43229 6.375C8.43229 5.89175 8.04054 5.5 7.55729 5.5C7.07404 5.5 6.68229 5.89175 6.68229 6.375C6.68229 6.85825 7.07404 7.25 7.55729 7.25Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.01562 3.75C2.01562 2.7835 2.79913 2 3.76562 2H14.2656C15.2321 2 16.0156 2.7835 16.0156 3.75V14.25C16.0156 15.2165 15.2321 16 14.2656 16H3.76562C2.79913 16 2.01562 15.2165 2.01562 14.25V3.75ZM3.76562 3.16667C3.44346 3.16667 3.18229 3.42783 3.18229 3.75V14.25C3.18229 14.5722 3.44346 14.8333 3.76562 14.8333H14.2656C14.5878 14.8333 14.849 14.5722 14.849 14.25V3.75C14.849 3.42783 14.5878 3.16667 14.2656 3.16667H3.76562Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }